var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRevenue1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FFE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 16.6667H3.33398C3.06065 16.6667 2.83398 16.44 2.83398 16.1667C2.83398 15.8934 3.06065 15.6667 3.33398 15.6667H16.6673C16.9406 15.6667 17.1673 15.8934 17.1673 16.1667C17.1673 16.44 16.9406 16.6667 16.6673 16.6667Z",
    fill: "#EE0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.66665V16.6666H11.5V4.66665C11.5 3.93331 11.2 3.33331 10.3 3.33331H9.7C8.8 3.33331 8.5 3.93331 8.5 4.66665Z",
    fill: "#EE0033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.66665V16.6666H6.66667V8.66665C6.66667 7.93331 6.4 7.33331 5.6 7.33331H5.06667C4.26667 7.33331 4 7.93331 4 8.66665Z",
    fill: "#EE0033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 12V16.6667H16.0007V12C16.0007 11.2667 15.734 10.6667 14.934 10.6667H14.4007C13.6007 10.6667 13.334 11.2667 13.334 12Z",
    fill: "#EE0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevenue1);
export default __webpack_public_path__ + "static/media/icon-revenue-1.8f9061410fd823799368731cfb018e00.svg";
export { ForwardRef as ReactComponent };